import type { ReactNode } from 'react';
import { ArrowUpDown, Check, X } from 'lucide-react';
import { Button } from '@/components/atoms/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/atoms/dropdown-menu';
import { cn } from '@/lib/utils';

export interface EntityListSortOption {
  label: string;
  icon: ReactNode;
}

interface EntityListSortMenuProps {
  activeIndex: number;
  activeLabel: string;
  options: EntityListSortOption[];
  onSelect: (index: number) => void;
  onReset: () => void;
}

export function EntityListSortMenu({
  activeIndex,
  activeLabel,
  options,
  onSelect,
  onReset,
}: EntityListSortMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="icon"
          className={cn('h-8 w-8 shrink-0', activeIndex !== 0 && 'border-primary text-primary')}
          title={activeLabel}
        >
          <ArrowUpDown size={13} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {activeIndex !== 0 && (
          <>
            <DropdownMenuItem onSelect={onReset} className="gap-2 text-muted-foreground text-xs">
              <X size={11} />
              Reset sort
            </DropdownMenuItem>
            <DropdownMenuSeparator />
          </>
        )}
        {options.map((option, index) => (
          <DropdownMenuItem
            key={`${option.label}-${index}`}
            onSelect={() => onSelect(index)}
            className={cn('gap-2', activeIndex === index && 'font-medium text-primary')}
          >
            <span className="text-muted-foreground">{option.icon}</span>
            <span>{option.label}</span>
            {activeIndex === index && <Check size={11} className="ml-auto" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
